"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TextTooltipState_1 = require("./TextTooltipState");
var styles = require("./TextTooltip.scss");
var ui_components_1 = require("@idp/ui-components");
var utils_1 = require("@idp/ui-components/utils");
var ReportingService_1 = require("../../../../api/ReportingService");
var StateProvider_1 = require("../../../../api/StateProvider");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var CartUtilFunctions_1 = require("../../../../utils/CartUtilFunctions");
var icons = require("../../../../styles/ccc-icons-cart.scss");
var TextTooltip = /** @class */ (function (_super) {
    __extends(TextTooltip, _super);
    function TextTooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new TextTooltipState_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.reportingService = new ReportingService_1.default();
        _this.triggerCartPageLoadReporting = true;
        _this.bindAll();
        return _this;
    }
    TextTooltip.prototype.bindAll = function () {
        this.documentClickEventListener = this.documentClickEventListener.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.togglePopUp = this.togglePopUp.bind(this);
        this.removeDocumentClickEventListener = this.removeDocumentClickEventListener.bind(this);
        this.showPlanToolTip = this.showPlanToolTip.bind(this);
        this.showPlanToolTipContent = this.showPlanToolTipContent.bind(this);
    };
    TextTooltip.prototype.componentWillUnmount = function () {
        this.removeDocumentClickEventListener();
    };
    TextTooltip.prototype.documentClickEventListener = function () {
        document.addEventListener('click', this.handleClick, false);
    };
    TextTooltip.prototype.removeDocumentClickEventListener = function () {
        document.removeEventListener('click', this.handleClick, false);
    };
    TextTooltip.prototype.handleClick = function (evt) {
        if (!(this.tooltipWrapper.contains(evt.target))) {
            this.togglePopUp(false);
            evt.preventDefault();
        }
    };
    TextTooltip.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { id: utils_1.default('Text', 'Tooltip', "Popup_" + this.props.options.losgId), ref: function (node) { _this.tooltipWrapper = node; } },
                React.createElement(React.Fragment, null,
                    React.createElement(ui_components_1.Link, { data: { content: this.props.data.linkText }, events: { onClick: this.showPlanToolTip }, options: { className: [styles.planTooltipLink, styles.plantooltip].join(' ') }, testId: utils_1.default('Line', 'Plan', 'Details') }, this.showPlanToolTipContent())))));
    };
    TextTooltip.prototype.togglePopUp = function (open) {
        var _this = this;
        this.setState({ showPopUp: open }, function () {
            if (_this.state.showPopUp) {
                _this.documentClickEventListener();
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_EDIT_POPUP_URL);
            }
            else {
                _this.removeDocumentClickEventListener();
                if (_this.triggerCartPageLoadReporting) {
                    _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
                }
                else {
                    _this.triggerCartPageLoadReporting = true;
                }
            }
        });
    };
    TextTooltip.prototype.showPlanToolTip = function () {
        var _this = this;
        this.reportingService.fireLinkClickWithOutPageLoad(this.props.data.linkText, ReportingService_1.PageUrls.CART_PAGE);
        this.setState({ showPopUp: !this.state.showPopUp }, function () {
            if (_this.state.showPopUp) {
                _this.documentClickEventListener();
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.WIRELESS_PLAN_MODAL);
            }
            else {
                _this.removeDocumentClickEventListener();
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
            }
        });
    };
    TextTooltip.prototype.showPlanToolTipContent = function () {
        if (this.state.showPopUp && this.props.options.mnmPlanDetails &&
            this.props.options.mnmPlanDetails.MnM) {
            var lineName = this.props.options.subscriber && this.props.options.subscriber.firstName ?
                this.props.options.subscriber.firstName.toUpperCase() + "'S PLAN" :
                "LINE " + this.props.options.losgId + " - PLAN";
            return (React.createElement("div", { className: [styles.tooltiptext, styles.plantooltipMobileView].join(' ') },
                React.createElement("div", { className: styles.planLineName },
                    " ",
                    lineName,
                    " "),
                React.createElement("div", { className: styles.planItem },
                    React.createElement("div", null,
                        React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false,
                                text: this.props.options.mnmPlanDetails.MnM.mnmPlanName }, options: { className: styles.lineItemName } })),
                    React.createElement("div", null,
                        React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('TextTooltip', 'Plan', 'Price'), data: { price: this.props.options.mnmPlanDetails.MnM.mnmPlanAmount }, options: {
                                className: styles.lineItemPrice,
                                decimalPoints: 2,
                                type: PriceContainerProps_1.PricingType.XSMALL,
                            } }))),
                this.props.options.promotions && this.props.options.promotions.length > 0 &&
                    React.createElement("div", { className: styles.promoContainer }, this.showPromotionText(this.props.options.mnmPlanDetails)),
                React.createElement("div", { className: styles.solidLine }),
                React.createElement("div", { className: styles.planItem },
                    React.createElement("div", null,
                        React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: 'Monthly charge' }, options: { className: styles.planMonthlyCharge } })),
                    React.createElement("div", null,
                        React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', 'Plan', 'Price'), data: { price: this.props.options.mnmPlanDetails.MnM.mnmMonthlyTotalAmount }, options: {
                                className: styles.lineItemPrice,
                                decimalPoints: 2,
                                type: PriceContainerProps_1.PricingType.XSMALL,
                            } }))),
                React.createElement("div", { className: styles.planFotterMessage }, " Excludes monthly taxes and other fees. ")));
        }
        else if (this.state.showPopUp && this.props.children && !this.props.options.mnmPlanDetails) {
            var toolTipStyles = [styles.tooltiptext, styles.plantooltipMobileView].join(' ');
            return (React.createElement("div", { className: toolTipStyles }, this.props.children));
        }
        else {
            return (React.createElement(React.Fragment, null));
        }
    };
    TextTooltip.prototype.showPromotionText = function (mnmPlanDetails) {
        var _this = this;
        var elements = [];
        var MnmPromotionReferences = mnmPlanDetails.MnM.mnmPromotionReferences;
        var imageStyle = [icons.cccIconCart, icons.cccIconCartSignatureBookmark].join(' ');
        MnmPromotionReferences.forEach(function (promoRef, promoIndex) {
            var _a;
            var promotion = _this.props.options.promotions
                .find(function (promo) { return promo.id === promoRef; });
            if (promotion) {
                elements.push(React.createElement("div", { className: styles.planItem, key: promoIndex },
                    React.createElement("div", null,
                        _this.props.options.isSignatureFlagEnabled && ((promotion === null || promotion === void 0 ? void 0 : promotion.promotionCategory) === 'iruPlanDiscount'
                            || ((_a = promotion === null || promotion === void 0 ? void 0 : promotion.discountCategory) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'noncontractual') &&
                            !CartUtilFunctions_1.isSMBCustomer() && !CartUtilFunctions_1.isFNIntentPresent() && !CartUtilFunctions_1.isFNUserWithConsumerLine() &&
                            React.createElement("span", { className: styles.iconBookmark32 }, (CartUtilFunctions_1.isAppreciationOfferPresent()) ?
                                React.createElement("img", { className: styles.appreciationIcon, src: 'https://www.att.com/idpassets/global/icons/svg/retail-financial/functional-icon_financial-security-filled_32.svg', alt: 'appreciationIcon' }) : React.createElement("i", { "aria-label": "Icon", className: imageStyle })),
                        React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: promotion.promotionName }, options: { className: styles.promotionText } })),
                    React.createElement("div", null,
                        React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', 'Plan', 'Price'), data: { price: promotion.amount }, options: {
                                className: styles.promotionPrice,
                                decimalPoints: 2,
                                isDataPriceNegative: true,
                                type: PriceContainerProps_1.PricingType.XSMALL,
                            } }))));
            }
        });
        return elements;
    };
    return TextTooltip;
}(React.Component));
exports.default = TextTooltip;
//# sourceMappingURL=TextTooltip.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/TextTooltip/TextTooltip.js
// module id = 2290
// module chunks = 8